import { checkedRule, requiredRule } from '~/shared/utils/validation'
import { Form } from '~/shared/api'

export default class AgreementsSignatureForm extends Form {
  readonly documentId: string = ''
  readonly versionId: string = ''
  checked: boolean = false

  constructor(documentId: string, versionId: string) {
    super()
    this.documentId = documentId
    this.versionId = versionId
    this.ignoreKeys = [...this.ignoreKeys, 'checked']
  }

  static rules() {
    return {
      documentId: requiredRule,
      versionId: requiredRule,
      checked: checkedRule
    }
  }
}
